module.exports = __webpack_public_path__ + "img/icon-no-data.5965ada3.png";